import { useMemo } from 'react';
import {
  useGetNoticeComponentRecordsQuery,
  useGetMaintenanceNoticesQuery,
  useLazyGetMaintenanceNoticesQuery,
} from '../services/edgeApi';
import { usePaginatedResource } from './usePaginatedResource';
import { NoticeSourceType } from '../types/api/NoticeRecord';

export const useNoticeRecords = ({
  startGasDate,
  endGasDate,
  tspIds,
  sourceTypes,
  searchText,
}: {
  startGasDate?: string;
  endGasDate?: string;
  tspIds?: number[];
  sourceTypes?: NoticeSourceType[];
  searchText?: string;
}) => {
  const [lazyTrigger] = useLazyGetMaintenanceNoticesQuery();
  const _filters = useMemo(() => {
    return {
      startGasDate,
      endGasDate,
      tsps: tspIds,
      sourceTypes,
      limit: 200,
    };
  }, [startGasDate, endGasDate, tspIds, sourceTypes, searchText]);
  const payload = usePaginatedResource(
    useGetMaintenanceNoticesQuery,
    _filters,
    searchText ?? '',
    {
      pageSize: 200,
    },
    lazyTrigger,
  );
  return payload;
};

export const useNoticeComponentRecords = (
  search: string,
  gasDate: string,
  filters?: { tsps: number[]; startDate?: string; endDate?: string },
) => {
  const _filters = useMemo(() => {
    return {
      ...filters,
      tsps: filters?.tsps ?? [],
      gasDate: gasDate,
      limit: 10,
    };
  }, [filters, gasDate]);

  const payload = usePaginatedResource(
    useGetNoticeComponentRecordsQuery,
    _filters,
    search,
  );

  return payload;
};
